var locale = {
  'login.bell.title': '通知',
  'login.account.title': '帳戶',
  'login.account.user.id': '用戶',
  'login.account.user.info': '個人資訊',
  logout: '登出',
  login: '登录'
};
export default locale;